import { render } from "./Pacientes.vue?vue&type=template&id=311ca9cd&scoped=true"
import script from "./Pacientes.vue?vue&type=script&lang=js"
export * from "./Pacientes.vue?vue&type=script&lang=js"

import "./Pacientes.vue?vue&type=style&index=0&id=311ca9cd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-311ca9cd"]])

export default __exports__